import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import PotsCrousel from "./PotsCrousel";

const Pots = () => {
  const user = localStorage.getItem("user");
  return (
    <Box mb={10}>
      <Text
        className="oswald-font"
        color={"#3C375F"}
        fontSize={{ md: "25px", base: "20px" }}
        fontWeight={"bold"}
      >
        Pots
      </Text>
      <Flex mt={5} alignItems={"center"}>
        <Box w={{ md: "100%", base: "100%" }}>
          <PotsCrousel />
        </Box>
      </Flex>
    </Box>
  );
};

export default Pots;
